import ProductAttribute from './styles';
export default ProductAttribute;